import { Snapshot } from '@ember-data/store';
import ApplicationAdapter from 'uplisting-frontend/adapters/application';
import type ModelRegistry from 'ember-data/types/registries/model';

interface IRoomQuery {
  propertyId: string;
}

function propertyIdOf(snapshot: Snapshot<keyof ModelRegistry>): string {
  const room = snapshot as unknown as Snapshot<'room'>;

  return room.belongsTo('property', { id: true }) as string;
}

export default class RoomAdapter extends ApplicationAdapter {
  urlForQuery({ propertyId }: IRoomQuery): string {
    return `${this.host}/v2/properties/${propertyId}/rooms`;
  }

  urlForCreateRecord<K extends keyof ModelRegistry>(
    _modelName: K,
    snapshot: Snapshot<K>,
  ): string {
    return this.urlForQuery({ propertyId: propertyIdOf(snapshot) });
  }

  urlForUpdateRecord<K extends keyof ModelRegistry>(
    id: string,
    _modelName: K,
    snapshot: Snapshot<K>,
  ): string {
    return `${this.urlForQuery({ propertyId: propertyIdOf(snapshot) })}/${id}`;
  }

  urlForDeleteRecord<K extends keyof ModelRegistry>(
    id: string,
    modelName: K,
    snapshot: Snapshot<K>,
  ): string {
    return this.urlForUpdateRecord(id, modelName, snapshot);
  }

  query(_store, _type, query: IRoomQuery) {
    return this.ajax(this.urlForQuery(query), 'GET');
  }
}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    room: RoomAdapter;
  }
}
